<mat-error *ngIf="errorMessage !== null">
	<i class="mdi mdi-information-variant"></i> {{errorMessage}}
</mat-error>